<!--
  ~ Copyright (c) 2022. Slimme Infrasoftware B.V. Apeldoorn /
  ~ Spin in het Web B.V. Apeldoorn.
  ~ Deze software mag alleen gebruikt / bekeken / gewijzigd worden
  ~ volgens de voorwaarden die zijn vastgelegd in de overeenkomst
  ~ tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
  ~ overeenkomsten tussen Slimme Infrasoftware B.V en
  ~ Spin in het Web B.V.
  -->

<datatable #datatable [definition]="tableDefinition" [data]="tableData" [autoUpdate]="false" stickyheaders (rijklik)="edit($event.id)"></datatable>
<div class="footer">
  <div links>{{datatable.filterRijen}} / {{datatable.rijen}}</div>
  <div rechts><button class="btn btn-success" *ngIf="api.can('gebruiker','full')" (click)="nieuw()">Nieuw...</button></div>
</div>
